import { ArcMark, Img, Lines, Reveal, SectionHead } from "../lib/site";

const frases = [
  "El dürüm lleva ternera, lechuga, tomate y salsa de yogur. ¿Te lo preparo?",
  "Esa calle nos pilla fuera de la zona de reparto, pero puedes recogerlo en quince minutos.",
  "Apuntado sin cebolla. ¿Algo de beber para acompañar?",
];

export function ComoSuena() {
  return (
    <section id="como-suena" className="relative flex min-h-screen items-end overflow-hidden text-crema" data-testid="section-como-suena">
      <div className="plx-wrap" data-plx="0.15">
        <div className="plx-in">
          <Img
            src="https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&q=80&w=2000"
            alt="Cocina abierta de un restaurante en plena hora punta"
            name="cocina-hora-punta"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(6,23,19,0.62) 0%, rgba(6,23,19,0.35) 32%, rgba(6,23,19,0.85) 66%, rgba(6,23,19,0.97) 100%)",
        }}
        aria-hidden="true"
      />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 pb-24 pt-40 md:px-8">
        <SectionHead num="01" label="Cómo suena" />
        <Lines
          className="mt-10 max-w-3xl font-display display-track text-3xl leading-[1.05] sm:text-4xl lg:text-5xl"
          lines={["Suena a alguien que", "se sabe tu carta."]}
        />
        <Reveal delay={160}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-crema/85 md:text-lg">
            Al descolgar avisa de que es un asistente. A partir de ahí habla
            como habla tu mostrador: confirma cada dato, resuelve dudas de la
            carta y cierra el pedido.
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-3">
          {frases.map((f, i) => (
            <Reveal key={f} delay={200 + i * 100} className="border-l border-salvia/40 pl-6">
              <p className="serif-accent text-xl leading-snug text-crema/90 md:text-2xl">«{f}»</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

const pasos = [
  {
    n: "01",
    t: "Desvías el teléfono",
    d: "Le pides a tu operador un desvío al número que te damos. Es el único trámite y se hace en cinco minutos.",
  },
  {
    n: "02",
    t: "Kanvia contesta",
    d: "Al primer tono. Conoce tu carta, tus precios, tu zona de reparto, tu pedido mínimo y tus horarios.",
  },
  {
    n: "03",
    t: "El pedido llega",
    d: "Por correo, por WhatsApp o impreso en cocina. Y puedes escuchar cualquier llamada cuando quieras.",
  },
];

export function ComoFunciona() {
  return (
    <section id="como-funciona" className="bg-papel py-28 text-noche md:py-36" data-testid="section-como-funciona">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHead num="02" label="Cómo funciona" />
        <Lines
          className="mt-10 font-display display-track text-3xl leading-[1.05] sm:text-4xl lg:text-5xl"
          lines={["Tres pasos.", <span key="x" className="serif-accent">Ninguno es tuyo.</span>]}
        />
        <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-0 md:divide-x md:divide-noche/15">
          {pasos.map((p, i) => (
            <Reveal key={p.n} delay={i * 90} className={i > 0 ? "md:pl-10" : "md:pr-10"}>
              <span className="serif-accent block text-6xl text-noche/25" aria-hidden="true">{p.n}</span>
              <h3 className="mt-5 font-display text-xl display-track">{p.t}</h3>
              <p className="mt-3 max-w-xs text-sm leading-relaxed text-noche/75">{p.d}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={120}>
          <p className="mt-14 max-w-xl text-base leading-relaxed text-noche/75 md:text-lg">
            Mientras tanto, en la cocina todo sigue igual. La única diferencia
            es que el teléfono deja de sonar encima de la mesa de pase.
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[
            {
              src: "https://customer-assets-agu9un31.emergentagent.net/job_kanvia-voice-ai/artifacts/piygk3qt_pexels-mikhail-nilov-8093949.webp",
              alt: "Cocinero cortando verduras en la tabla durante el servicio",
              name: "cocina-trabajando",
            },
            {
              src: "https://customer-assets-agu9un31.emergentagent.net/job_kanvia-voice-ai/artifacts/0dewsrnu_pexels-marioschafer-11322617.webp",
              alt: "Cocineros flambeando en los fogones con una llamarada",
              name: "fogones-en-servicio",
            },
            {
              src: "https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&q=80&w=900",
              alt: "Cocinero terminando un plato en el pase, con luz tenue",
              name: "pase-en-servicio",
            },
            {
              src: "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&q=80&w=900",
              alt: "Barra de un local iluminada con luz cálida por la noche",
              name: "local-de-noche",
            },
          ].map((f, i) => (
            <Reveal key={f.name} delay={i * 90} className="zoomwrap aspect-[4/5]">
              <Img src={f.src} alt={f.alt} name={f.name} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

const incluye = [
  { t: "Pedidos completos", d: "A domicilio y para recoger, con dirección, piso y teléfono de contacto." },
  { t: "Tu carta entera", d: "Responde qué lleva cada plato y dice claro lo que no tenéis." },
  { t: "Cambios sobre la marcha", d: "«Sin cebolla», «quítame la bebida», «mejor de ternera»." },
  { t: "Tus reglas", d: "Pedido mínimo, zona de reparto, gastos de envío, horarios y tiempos." },
  { t: "Paso a una persona", d: "Si el cliente lo pide, o hay una alergia grave, transfiere la llamada." },
  { t: "Veinticuatro horas", d: "Todos los días del año. No libra, no se pone malo y no se va a otro sitio." },
];

export function QueIncluye() {
  return (
    <section className="bg-noche py-28 text-crema md:py-36" data-testid="section-incluye">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHead num="03" label="Qué incluye" />
        <Lines
          className="mt-10 font-display display-track text-3xl leading-[1.05] sm:text-4xl lg:text-5xl"
          lines={["Todo esto,", <span key="x" className="serif-accent">desde el primer día.</span>]}
        />
        <div className="mt-16 grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          <Reveal className="zoomwrap aspect-[4/5] lg:aspect-auto lg:h-full lg:row-span-2">
            <Img
              src="https://images.unsplash.com/photo-1538488881038-e252a119ace7?auto=format&fit=crop&q=80&w=1000"
              alt="Interior de un bar en pleno servicio nocturno, con la barra iluminada"
              name="bar-en-servicio"
            />
          </Reveal>
          {incluye.map((c, i) => (
            <Reveal key={c.t} delay={(i + 1) * 90} className="border-t border-salvia/25 pt-6">
              <h3 className="font-display text-lg display-track">{c.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-crema/80">{c.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

const cinta = [
  "Tú, la cocina. Nosotros, el teléfono.",
  "Atiende más, pierde menos.",
  "Tus clientes llaman, Kanvia responde.",
  "24 horas, todos los días.",
];

export function Marquee({ id = "marquee" }) {
  const group = (key) => (
    <div key={key} className="flex shrink-0 items-center" aria-hidden={key === 1}>
      {cinta.map((f) => (
        <span key={f} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-2xl display-track text-crema/90 md:text-3xl">
            {f}
          </span>
          <ArcMark className="h-6 w-6 shrink-0 text-salvia/70" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="mq overflow-hidden border-y border-salvia/15 bg-hondo py-7" data-testid={id}>
      <div className="mq-track">{[group(0), group(1)]}</div>
    </div>
  );
}
